/**
 * SEO Meta Composable
 * Provides unified SEO meta tags for all pages following seo-meta-optimizer skill.
 */
export const useSiteSeoMeta = (options: {
  title: string
  description: string
  image?: string
  url?: string
}) => {
  const img = options.image ?? SEO_DEFAULTS.OG_IMAGE
  const fullTitle = `${options.title} | ${SEO_DEFAULTS.TITLE}`

  useHead({
    title: fullTitle,
    meta: [
      { name: 'description', content: options.description },
      // Open Graph
      { property: 'og:title', content: fullTitle },
      { property: 'og:description', content: options.description },
      { property: 'og:image', content: img },
      { property: 'og:type', content: 'website' },
      // Twitter Card
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: fullTitle },
      { name: 'twitter:description', content: options.description },
      { name: 'twitter:image', content: img },
    ],
  })
}
